import { BlurRadius } from '@vonage/ml-transformers';
import DefaultConfig from './defaultConfig';

const defaultBlurRadius = BlurRadius.High;

const getDefaultConfig = opt => ({
  ...DefaultConfig.getConfig(opt),
  transformerType: 'BackgroundBlur',
  radius: defaultBlurRadius,
});

const isValidBlurStrength = blurStrength =>
  blurStrength === 'low' || blurStrength === 'high';

const toBlurRadius = blurStrength =>
  (blurStrength === 'low' ? BlurRadius.Low : BlurRadius.High);

const isValidConfig = (config) => {
  if (config?.type !== 'backgroundBlur') {
    return false;
  }

  // blurStrength is optional.  If defined, then make sure it's valid.
  const { blurStrength } = config;
  return blurStrength ? isValidBlurStrength(blurStrength) : true;
};

const BackgroundBlurConfig = {
  isValidConfig,
  getConfig: (opt = {}) => {
    const config = getDefaultConfig(opt);
    const { blurStrength } = opt;

    if (isValidBlurStrength(blurStrength)) {
      config.radius = toBlurRadius(blurStrength);
    }

    return config;
  },
};

export default BackgroundBlurConfig;
